"use client";

import React from "react";

export default function BoostButton({ disabled = false, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="px-2.5 py-1 rounded-md border border-[#d8d5d0] text-[11px] font-medium text-[#5f5e59] hover:text-[#27251f] hover:border-[#c4c0b8] bg-[#faf8f6] transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:text-[#5f5e59]"
    >
      Boost
    </button>
  );
}
